<template>
  <BookingsBase
    ref="bookingsBase"
    user-type="organizer"
    header-button-icon="calendar_month"
    header-button-color="primary"
    :header-button-label="$t('bookings.goToCalendar')"
    @header-button-click="goToCalendar"
  >
    <template #booking-actions="{ booking, handlers }">
      <AppActionButton
        v-if="isRejectable(booking.status)"
        type="cancel"
        :label="$t('bookings.dialog.reject.action')"
        icon="close"
        :loading="handlers.isProcessing(booking.id, 'rejected')"
        @click="processBooking(booking, 'rejected', handlers)"
        class="q-mr-sm"
      />

      <AppActionButton
        v-if="booking.status === 'pending'"
        type="accept"
        :label="$t('bookings.dialog.accept.action')"
        icon="check"
        :loading="handlers.isProcessing(booking.id, 'accepted')"
        @click="processBooking(booking, 'accepted', handlers)"
      />
    </template>
  </BookingsBase>
</template>

<script>
import BookingsBase from '@/pages/bookings/components/BookingsBase.vue';
import AppActionButton from '@/components/AppActionButton.vue';

export default {
  name: 'BookingsPhotographer',
  components: { BookingsBase, AppActionButton },
  methods: {
    goToCalendar() {
      this.$router.push({ name: 'bookings-calendar' });
    },
    isRejectable(status) {
      return status === 'pending' || status === 'accepted';
    },
    processBooking(booking, newStatus, handlers) {
      const action = newStatus === 'accepted' ? 'accept' : 'reject';

      this.$refs.bookingsBase?.openDialog(booking, action, () =>
        handlers.updateStatus(
          booking.id,
          newStatus,
          `bookings.dialog.${action}.success`,
          `bookings.dialog.${action}.error`
        )
      );
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/bookings.scss';
</style>
